<template>
  <div v-if="vonageStore.collection.length > 0" class="p-7 text-center mx-auto">
    <h3 class="mt-2 text-lg font-medium text-gray-900 mb-5">{{ $t('whatsapp.approvedNumbers') }}</h3>
    <div class="inline-block shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
      <table class="divide-y divide-gray-300">
        <thead class="bg-gray-50">
          <tr>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{$t("whatsapp.name")}}</th>
            <th scope="col" class="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6">{{$t("whatsapp.phoneNumber")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("fanpages.lastUpdate")}}</th>
            <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">{{$t("whatsapp.status")}}</th>
          </tr>
        </thead>
        <tbody class="divide-y divide-gray-200 bg-white">
          <tr v-for="vonage of vonageStore.collection" v-bind:key="vonage.id">
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">{{vonage.attributes['name']}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">{{vonage.attributes['phone-number']}}</td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">
              <Datetime v-bind:date="vonage.attributes['last-updated-at']" />
            </td>
            <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 ">
              <span class="inline-flex rounded-full px-2 text-xs font-semibold leading-5" :class="{'text-red-800 bg-red-100': !vonage.attributes['active'], 'text-green-800 bg-green-100 ': vonage.attributes['active']}">
                <span v-if="vonage.attributes['active']">
                  {{$t("whatsapp.active")}}
                </span>
                <span v-else>{{ $t('whatsapp.disabled') }}</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="px-4 sm:px-5 lg:px-5 mt-5 text-center max-w-6xl m-auto" v-if="$root.currentBusiness">
    <PhoneMissedCallIcon v-if="vonageStore.collection.length === 0" class="mx-auto h-12 w-12 text-gray-400 mt-6 mb-5" />
    <PhoneIncomingIcon v-else class="mx-auto h-12 w-12 text-gray-400 mt-6 mb-5" />
    <h3 class="mt-2 text-lg font-medium text-gray-900 mb-5">
      <span v-if="vonageStore.collection.length === 0">{{ $t('whatsapp.noConnection') }}</span>
      <span v-else>{{ $t('whatsapp.extraConnection') }}</span>
    </h3>
    <p class="mt-1 text-sm text-gray-500 leading-6">{{ $t('whatsapp.description') }}</p>
    <div class="mt-3">
      <iframe style="border: 0; width: 100%; height: 900px; margin: 0 auto" :src="formURL">
      </iframe>
    </div>
  </div>
</template>

<script>
import { useVonageStore } from '@/stores/vonageIntegrations';
import Datetime from '../building_blocks/DateTime.vue'


import {
  PhoneMissedCallIcon, PhoneIncomingIcon,
} from '@heroicons/vue/outline'

export default {
  name: 'WhatsappPage',
  setup() {
    let vonageStore = useVonageStore();
    return { vonageStore };
  },
  components: {
    Datetime,
    //
    PhoneMissedCallIcon,
    PhoneIncomingIcon,
  },
  computed: {
    formURL() {
      let language = navigator.language.split('-')[0];
      if (language === 'es') {
        return 'https://docs.google.com/forms/d/e/1FAIpQLSfeUnaTV76QOe8Z-ZbBSxQOl1uyG6YLfYSXpkv-rB8uI_Wazw/viewform?embedded=true';
      }
      if (language === 'pl') {
        return 'https://docs.google.com/forms/d/e/1FAIpQLSdpBHuw_adoF45PiNP9gdtyJubtm3QDjnCxo-9PsPKsjAe8QQ/viewform?embedded=true';
      }
      return 'https://docs.google.com/forms/d/e/1FAIpQLSd24tA_ihGDTuVrhV5GPXimGU-3k8ATPW1lzz36Fj4QIITCog/viewform?embedded=true';
    }
  }
}
</script>
